import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_ENDPOINT } from '../../utils/Constants';

import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import dayjs from 'dayjs';
import Plotly from 'plotly.js';
import createPlotlyComponent from 'react-plotly.js/factory';
const Plot = createPlotlyComponent(Plotly);

const Graph5 = () => {
  const [startDate, setStartDate] = React.useState<Date | null>(null);
  const [endDate, setEndDate] = React.useState<Date | null>(null);
  const [operatorA, setOperatorA] = useState([]);
  const [operatorB, setOperatorB] = useState([]);
  const [taskset, setTaskset] = useState([]);

  const [selectedTaskset, setSelectedTaskset] = React.useState('');
  const [selectedOperatorA, setSelectedOperatorA] = React.useState('');
  const [selectedOperatorB, setSelectedOperatorB] = React.useState('');

  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [rowsTitle, setRowTitle] = useState([]);

  const layout: any = {
    title: 'オペレーター別タスクセット平均時間',
    barmode: 'stack',
    yaxis: {
      autorange: true,
      title: '時間 (秒)',
      titlefont: {
        size: 20,
      },
    },
  };

  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectedTaskset(event.target.value as string);
  };

  const handleChange2 = (event: SelectChangeEvent) => {
    setSelectedOperatorA(event.target.value as string);
  };

  const handleChange3 = (event: SelectChangeEvent) => {
    setSelectedOperatorB(event.target.value as string);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      axios
        .post(API_ENDPOINT + 'graph5', {
          startDate,
          endDate,
          selectedTaskset,
          selectedOperatorA,
          selectedOperatorB,
        })
        .then((res) => {
          const data = res.data.data;
          setData(res.data.data);

          // table data
          const rw = [];
          const operatorList = [];
          for (let i= 0; i < data.length; i++){
            for (let k= 0; k < data[i].operator.length; k++){
              if (operatorList.indexOf(data[i].operator[k]) === -1){
                operatorList.push(data[i].operator[k]);
              }
            }
          }
          for (let k= 0; k < operatorList.length; k++){
            rw.push({'operator': operatorList[k], 'data': []});
            for (let i= 0; i < data.length; i++){
              for (let m= 0; m < data[i].operator.length; m++){
                if (rw[k].operator === data[i].operator[m]){
                  rw[k].data.push({'taskName': data[i].task, 'duration': data[i].duration[m]});
                }
              }
            }
          }
          setRows(rw);
          setRowTitle([{'tasksetName': selectedTaskset.split(':')[1]}]);
        
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // -----------------
  const defaultTraces = useCallback((defaulTaskset, defaultOperatorA, defaultOperatorB ) => {
    axios.post(API_ENDPOINT + 'graph5', {
      'startDate': dayjs().subtract(1, 'd'),
      'endDate': dayjs(),
      'selectedTaskset': defaulTaskset,
      'selectedOperatorA': defaultOperatorA,
      'selectedOperatorB': defaultOperatorB
    })
      .then((res) => {
        const data = res.data.data;
        setData(res.data.data);

        // table data
        const rw = [];
        const operatorList = [];
        for (let i= 0; i < data.length; i++){
          for (let k= 0; k < data[i].operator.length; k++){
            if (operatorList.indexOf(data[i].operator[k]) === -1){
              operatorList.push(data[i].operator[k]);
            }
          }
        }
        for (let k= 0; k < operatorList.length; k++){
          rw.push({'operator': operatorList[k], 'data': []});
          for (let i= 0; i < data.length; i++){
            for (let m= 0; m < data[i].operator.length; m++){
              if (rw[k].operator === data[i].operator[m]){
                rw[k].data.push({'taskName': data[i].task, 'duration': data[i].duration[m]});
              }
            }
          }
        }
        setRows(rw);
        setRowTitle([{'tasksetName': defaulTaskset.split(':')[1]}]);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const getStatus = useCallback(() => {
    axios
      .get(API_ENDPOINT + 'graph5')
      .then((res) => {
        setTaskset(res.data.data[0]);
        setOperatorA(res.data.data[1]);
        setOperatorB(res.data.data[2]);
        if (res.data.data[2][1]){
          defaultTraces(
            res.data.data[0][0][0] + ':' + res.data.data[0][0][1],
            res.data.data[1][0][0] + ':' + res.data.data[1][0][1],
            res.data.data[2][1][0] + ':' + res.data.data[2][1][1]);
        }else{
          defaultTraces(
            res.data.data[0][0][0] + ':' + res.data.data[0][0][1],
            res.data.data[1][0][0] + ':' + res.data.data[1][0][1],
            res.data.data[2][0][0] + ':' + res.data.data[2][0][1]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [defaultTraces]);

  useEffect(() => {
    getStatus();
  }, [getStatus]);

  const traces: any = [];
  const rows2 = [];
  function createData2(task: string, duration: string, operator: string) {
    return { task, duration, operator };
  }
  Object.keys(data).forEach(function (key) {
    rows2.push(
      createData2(
        data[key].task,
        data[key].duration.join(','),
        data[key].operator.join(',')
      )
    );
    const trace = {
      x: data[key].operator,
      y: data[key].duration,
      name: data[key].task,
      hovertemplate: '<b>%{y}秒</b>',
      type: 'bar',
    };
    traces.push(trace);
  });

  return (
    <Stack spacing={2}>
      <Stack direction='row' spacing={2}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <FormControl fullWidth>
            <DatePicker
              label='Start Date'
              value={startDate}
              onChange={(newValue) => {
                setStartDate(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormControl>
          <FormControl fullWidth>
            <DatePicker
              label='End Date'
              value={endDate}
              onChange={(newValue) => {
                setEndDate(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormControl>
        </LocalizationProvider>

        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>実行タスクセット</InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={selectedTaskset}
            label='task set'
            onChange={handleChange1}
          >
            {taskset.map((item) => (
              <MenuItem value={item[0] + ':' + item[1]} key={item[0]}>
                {item[1]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>オペレーターA選択</InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={selectedOperatorA}
            label='Operator'
            onChange={handleChange2}
          >
            {operatorA.map((item) => (
              <MenuItem value={item[0] + ':' + item[1]} key={item[0]}>
                {item[1]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>オペレーターB選択</InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={selectedOperatorB}
            label='Operator'
            onChange={handleChange3}
          >
            {operatorB.map((item) => (
              <MenuItem value={item[0] + ':' + item[1]} key={item[0]}>
                {item[1]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button onClick={handleSubmit} variant='contained'>検索</Button>
      </Stack>

      <Plot data={traces} layout={layout} config={{'displayModeBar': false}} />

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>タスクセット</TableCell>
              <TableCell>オペレーター</TableCell>
              <TableCell>タスクセット平均継続時間(秒)</TableCell>
              <TableCell>タスク名</TableCell>
              <TableCell>タスク平均継続時間(秒)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsTitle.map((item) => {
              let tasksetrowSpanNum = 1 + 2 * rows.length;
              for (let i= 0; i < rows.length; i++){
                tasksetrowSpanNum += rows[i].data.length + 1;
              }
              return (
                <>
                  <TableRow key={item.tasksetName}>
                    <TableCell rowSpan={tasksetrowSpanNum}>{item.tasksetName}</TableCell>
                  </TableRow>
                  {rows.map((operator, i) => {
                    const rowSpanNum = 1 + operator.data.length;
                    let tasksetDurationSUM = 0;
                    for (let k= 0; k < operator.data.length; k++){
                      tasksetDurationSUM += parseInt(operator.data[k].duration);
                    }
                    return (
                      <>
                        <TableRow key={operator.operator+i}>
                          <TableCell rowSpan={rowSpanNum}>{operator.operator}</TableCell>
                          <TableCell rowSpan={rowSpanNum}>{tasksetDurationSUM}秒</TableCell>
                        </TableRow>
                        {operator.data.map((data, index) => {
                          return (
                            <TableRow key={operator.operator+i+data.taskName+index}>
                              <TableCell>{data.taskName}</TableCell>
                              <TableCell>{data.duration}秒</TableCell>
                            </TableRow>
                          );
                        })} 
                      </>
                    );
                  })}  
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <br />
    </Stack>
  );
};

export default Graph5;
